import {
  Camera,
  DeviceHub,
  Face,
  Garage,
  PortraitSharp,
  Thermostat,
} from '@mui/icons-material';
import { ReactElement } from 'react';
import { DeviceDiscriminator } from 'services/Devices/types';

const IVS_AVAILABLE_EVENTS = [
  { label: 'Cruzamento de linha', value: 'CROSSLINEDETECTION' },
  { label: 'Cruzamento de região', value: 'CROSSREGIONDETECTION' },
  { label: 'Deteccão de passada', value: 'PASTEDETECTION' },
  { label: 'Deteccão esquerda', value: 'LEFTDETECTION' },
  { label: 'Deteccão de permanência', value: 'STAYDETECTION' },
  { label: 'Deteccão de andarilho', value: 'WANDERDETECTION' },
  { label: 'Deteccão de movimento', value: 'MOVEDETECTION' },
  { label: 'Deteccão de vadiagem', value: 'RIOTERDETECTION' },
  { label: 'Deteccão de luta', value: 'FIGHTDETECTION' },
  {
    label: 'Deteccão de sobreposição de câmera',
    value: 'CAMERACOVERDDETECTION',
  },
  {
    label: 'Deteccão de vídeo anormal',
    value: 'VIDEOABNORMALDETECTION',
  },
  {
    label: 'Deteccão de corrente anormal',
    value: 'ABNORMALRUNDETECTION',
  },
  {
    label: 'Alarme deteccão de movimento',
    value: 'ALARM_MOTIONDETECT',
  },
  { label: 'Alarme local', value: 'ALARM_LOCALALARM' },
];

const LPR_AVAILABLE_EVENTS = [
  { label: 'Passar Sinal Vermelho', value: 'TRAFFIC_RUNREDLIGHT' },
  { label: 'Junção', value: 'TRAFFICJUNCTION' },
  { label: 'Acima da Velocidade', value: 'TRAFFIC_OVERSPEED' },
  { label: 'Abaixo da Velocidade', value: 'TRAFFIC_UNDERSPEED' },
  { label: 'Manual', value: 'TRAFFIC_MANUALSNAP' },
  { label: 'Estacionamento', value: 'TRAFFIC_PARKINGSPACEPARKING' },
  {
    label: 'Sem Estacionamento',
    value: 'TRAFFIC_PARKINGSPACENOPARKING',
  },
  { label: 'Sobre a Linha', value: 'TRAFFIC_OVERLINE' },
  { label: 'Retrogrado', value: 'TRAFFIC_RETROGRADE' },
  { label: 'Estacionamentos', value: 'TRAFFIC_PARKING' },
  { label: 'Rota Errada', value: 'TRAFFIC_WRONGROUTE' },
  { label: 'Cruzamento de Pista', value: 'TRAFFIC_CROSSLANE' },
  { label: 'Sobre a Linha Amarela', value: 'TRAFFIC_OVERYELLOWLINE' },
  {
    label: 'Placa Amarela na Pista',
    value: 'TRAFFIC_YELLOWPLATEINLANE',
  },
  {
    label: 'Prioridade de Pedestre',
    value: 'TRAFFIC_PEDESTRAINPRIORITY',
  },
  { label: 'Veiculo na Rota', value: 'TRAFFIC_VEHICLEINROUTE' },
  {
    label: 'Veiculo na Rota de Onibus',
    value: 'TRAFFIC_VEHICLEINBUSROUTE',
  },
  { label: 'Marcha a Ré', value: 'TRAFFIC_BACKING' },
  {
    label: 'Sem Cinto de Segurança',
    value: 'TRAFFIC_WITHOUT_SAFEBELT',
  },
];

const RECOGNITION_AVAILABLE_EVENTS = [
  { label: 'Detecção facial', value: 'FACE_DETECT' },
  { label: 'Reconhecimento facial', value: 'FACE_RECOGNITION' },
];

const TEMPERATURE_DETECTOR_AVAILABLE_EVENTS = [
  { label: 'Detecção de fogo', value: 'FIREDETECTION' },
  { label: 'Alerta de incêndio', value: 'FIREWARINING' },
  {
    label: 'Detecção de temperatura corporal',
    value: 'ANATOMY_TEMP_DETECT',
  },
  { label: 'Detecção de fumaça', value: 'SMOKEDETECTION' },
  { label: 'Detecção de fumante', value: 'SMOKING_DETECT' },
];

const CONTROLLER_AVAILABLE_EVENTS = [{ label: 'Acesso', value: 'ACCESS_CTL' }];

export const DeviceDetailsByDiscriminator: (deviceType: DeviceDiscriminator) =>
  | {
      icon: ReactElement;
      color: string;
      typeDescription: string;
      availableEvents: { label: string; value: string }[];
    }
  | undefined = (deviceType: DeviceDiscriminator) => {
  switch (deviceType) {
    case 'IvsCameraEntity':
      return {
        icon: <Camera />,
        color: 'warning',
        typeDescription: 'IVS',
        availableEvents: IVS_AVAILABLE_EVENTS,
      };
    case 'LprCameraEntity':
      return {
        icon: <Garage />,
        color: 'primary',
        typeDescription: 'LPR',
        availableEvents: LPR_AVAILABLE_EVENTS,
      };
    case 'RecognitionCameraEntity':
      return {
        icon: <Face />,
        color: 'success',
        typeDescription: 'FACIAL',
        availableEvents: RECOGNITION_AVAILABLE_EVENTS,
      };
    case 'TemperatureDetectorEntity':
      return {
        icon: <Thermostat />,
        color: 'error',
        typeDescription: 'TEMPERATURA',
        availableEvents: TEMPERATURE_DETECTOR_AVAILABLE_EVENTS,
      };

    case 'FacialControllerEntity':
      return {
        icon: <PortraitSharp />,
        color: 'success',
        typeDescription: 'Controlador facial Intelbras',
        availableEvents: CONTROLLER_AVAILABLE_EVENTS,
      };
    case 'ControlIdDeviceEntity':
      return {
        icon: <PortraitSharp />,
        color: 'success',
        typeDescription: 'Controlador facial ControlID',
        availableEvents: CONTROLLER_AVAILABLE_EVENTS,
      };
    case 'DvrEntity':
      return {
        icon: <DeviceHub />,
        color: 'success',
        typeDescription: 'DVR/NVR',
        availableEvents: [
          ...IVS_AVAILABLE_EVENTS,
          ...LPR_AVAILABLE_EVENTS,
          ...RECOGNITION_AVAILABLE_EVENTS,
          ...TEMPERATURE_DETECTOR_AVAILABLE_EVENTS,
          ...CONTROLLER_AVAILABLE_EVENTS,
        ],
      };
    default:
      return undefined;
  }
};

export default DeviceDetailsByDiscriminator;
